module.exports = __webpack_public_path__ + "img/bullet-03.afa79123.svg";